import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedConstants } from '@app/eds';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  //modalTitle provides the title of the modal
  modalTitle: string = SharedConstants.EMPTY_STRING;

  // Boolean to specify if close icon is required
  closeIconRequired = true;

  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.modalTitle = data.modalTitle;
    if (data && data.closeIconRequired === false) {
      this.closeIconRequired = false;
    }
  }

  /**
   * OnCloseModal method is used to close the modal
   */
  onCloseModal = () => this.dialogRef.close();

  /**
   * OnAddField method will help us to save the field data
   */
  onAddField = () => this.onCloseModal();
}
